<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
      :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' >
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='shieldrulename' :headerText='$t("Alarm.rulename")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='startdate' :headerText='$t("Alarm.starttime")' textAlign='Center' minWidth='10' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='enddate' :headerText='$t("Alarm.endtime")' textAlign='Center' minWidth='10' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='enableId' :headerText='$t("Alarm.status")' textAlign='Center' minWidth='10' :formatter='statusFormat' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getBlockingRuleData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='addDialog' :element='addDialogSetting.element' :styles='addDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AddRule ref='addContent'></AddRule>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import AddRule from './AddRule';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'blockingRuleTable',
  components: {
    CustomDialog,
    AddRule
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd' },
      contextMenuItems: [{
        text: `${this.$t('Alarm.add')}`
      }, {
        text: `${this.$t('Alarm.remove')}`
      }, {
        text: `${this.$t('Alarm.edit')}`
      }, {
        text: `${this.$t('Alarm.refresh')}`
      }, {
        text: `${this.$t('Alarm.able')}`
      }, {
        text: `${this.$t('Alarm.disable')}`
      }],
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {
        systemId: '1'
      },
      data: [],
      addDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.addBlockingRule'),
          refName: 'add',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.addConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  },
  methods: {
    statusFormat(grids, data) {
      return data.enableId === 0 ? this.$t('Alarm.able') : this.$t('Alarm.disable');
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      if (this.getCheckedData(true).length > 1) {
        childList[2].style.display = 'none';
      } else {
        childList[2].style.display = 'block';
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.add')}`:
          this.addFunc();
          break;
        case `${this.$t('Alarm.remove')}`:
          this.removeFunc();
          break;
        case `${this.$t('Alarm.edit')}`:
          this.editFunc();
          break;
        case `${this.$t('Alarm.refresh')}`:
          this.getBlockingRuleData();
          break;
        case `${this.$t('Alarm.able')}`:
          this.updateStatusFunc('enable');
          break;
        case `${this.$t('Alarm.disable')}`:
          this.updateStatusFunc('unenable');
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const ids = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        ids.push(checkedData[i].shieldruleid);
      }
      return ids;
    },
    getBlockingRuleData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      This.$axios.post('/lte/ems/fm/shield/querybypage', {
        pageNo: This.page.pageNo,
        pageSize: This.page.pageSize
      }).then((response) => {
        if (response && response.status === 200) {
          const result = response.data.resultVal;
          This.page.totalCount = result.totalCount;
          This.data = result.result;
        }
      });
    },
    addFunc() {
      this.addDialogSetting.element.title = this.$t('Alarm.addBlockingRule');
      this.$refs.addDialog.show();
      this.$refs.addContent.clearData();
    },
    addConfirmFunc() {
      const This = this;
      const ruleDatas = This.$refs.addContent.getRuleData();
      let url = '/lte/ems/fm/shield/addrule';
      if (this.addDialogSetting.element.title !== this.$t('Alarm.addBlockingRule')) {
        url = '/lte/ems/fm/shield/updaterule';
      }
      if (ruleDatas !== false) {
        This.$axios.post(url, ruleDatas).then((response) => {
          if (response && response.status === 200 && response.data.resultVal === true) {
            EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
            This.dialogHide();
            This.getBlockingRuleData();
          } else {
            EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
          }
        });
      }
    },
    removeFunc() {
      // 删除规则
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        This.$layer.confirm({
          msg: This.$t('Alarm.alarmDeleteConfirm'),
          btn1: {
            msg: This.$t('Alarm.cancel')
          },
          btn2: {
            msg: This.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/fm/shield/delete', This.getCheckedVals()).then((response) => {
                if (response && response.status === 200 && response.data.resultVal === true) {
                  EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
                }
                This.getBlockingRuleData();
              });
            }
          }
        });

      }
    },
    editFunc() {
      // 修改规则
      const This = this;
      This.addDialogSetting.element.title = This.$t('Alarm.editBlockingRule');
      const checkedData = This.getCheckedData(false);
      if (checkedData) {
        This.$refs.addDialog.show();
        This.$refs.addContent.clearData();
        This.$refs.addContent.setRuleId(checkedData[0]);
      }
    },
    updateStatusFunc(statusStr) {
      // 启用规则 禁用规则
      const This = this;
      const checkedData = This.getCheckedData(true);
      let str = '';
      switch (statusStr) {
        case 'enable':
          str = This.$t('Alarm.enableconfirm');
          break;
        case 'unenable':
          str = This.$t('Alarm.unenableconfirm');
          break;
        default:
      }
      if (checkedData) {
        This.$layer.confirm({
          msg: `${str}?`,
          btn1: {
            msg: this.$t('Alarm.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/fm/shield/updatestatus', {
                status: statusStr,
                ids: This.getCheckedVals()
              }).then((response) => {
                if (response && response.status === 200 && response.data.resultVal === true) {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
                }
                This.getBlockingRuleData();
              });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getBlockingRuleData();
  }
};
</script>
